import { ButtonProps } from "@mui/material";
import Button from "components/shared/Button";
import Modal, { TModalProps } from "components/shared/Modal";
import ModalActionButtons from "components/shared/ModalActionButtons";

export type TConfirmModalProps = Omit<TModalProps, "buttons" | "onClose"> & {
  isConfirmButtonDisabled?: boolean;
  onConclude?: (result: boolean) => void;
  confirmColor?: ButtonProps["color"];
  confirmButtonText: string;
  cancelButtonText: string;
  isConfirmButtonLoading?: boolean;
  showLoadingText?: boolean;
};

const ConfirmModal = ({
  isConfirmButtonDisabled = false,
  onConclude,
  confirmColor = "error",
  confirmButtonText,
  cancelButtonText,
  isConfirmButtonLoading,
  showLoadingText,
  children,
  ...props
}: TConfirmModalProps) => {
  const handleCancelClick = () => {
    onConclude?.(false);
  };

  const handleConfirmClick = () => {
    onConclude?.(true);
  };

  return (
    <Modal data-qaid="confirm-modal" {...props}>
      {children}
      <ModalActionButtons>
        <Button
          key="Cancel"
          variant="text"
          onClick={handleCancelClick}
          data-qaid="cancel-button"
        >
          {cancelButtonText}
        </Button>
        <Button
          color={confirmColor}
          disabled={isConfirmButtonDisabled}
          key="Confirm"
          variant="contained"
          onClick={handleConfirmClick}
          data-qaid="confirm-button"
          loading={isConfirmButtonLoading}
          {...(showLoadingText ? { loadingPosition: "start" } : {})}
        >
          {confirmButtonText}
        </Button>
      </ModalActionButtons>
    </Modal>
  );
};

export default ConfirmModal;
